import React from "react";
import { View, StyleSheet } from "react-native";
// import { Bubble } from "react-native-gifted-chat";
import { colors } from "../../const";
import { RoundedIcon } from "../../components";
import { audioToBase64 } from "../../functions";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome"
import { faStop, faMicrophone } from "@fortawesome/free-solid-svg-icons";
import posed from 'react-pose';
import { SoundManager } from "../../assets/soundManager2";
// import createSoundWave from "../../../Web/functions/createSoundWave";

window.MediaRecorder = window.MediaRecorder ? window.MediaRecorder : require('audio-recorder-polyfill')
window.AudioContext = (window.AudioContext || window.webkitAudioContext)

var recorder = null;
var mediaStream = null;
var context = null;
let mediaRecorder = null;
const soundManager = new SoundManager();

class Recorder extends React.Component {

    SoundObject = soundManager.createSound();

    constructor(props) {
        super(props);
        this.state = {
            playAudio: false,
            url: "",
            duration: "",
            currentTime: "",
            hasPermission: false,
            startAudio: false,
            recordingTimer: "",
            isAudioRecorded: false,
            audioBase64: undefined,
            audioPath: undefined,
            isVoiceAnim: true,
        }
        props.arcRefs && props.arcRefs(this)
        this.interval_anim = null;
    }
    
    _startRecording = () => {
        this.interval_anim = setInterval(() => {
            this.setState({ isVoiceAnim: this.state.isVoiceAnim ? false : true });
        }, 1000);

        if (window.webkit && window.wv) {
            this.recordProgress = setInterval(() => {
                let seconds = Math.floor(this.state.recordingTimer + 1);
                this.props.onRecordingProgress(seconds);
                this.setState({ recordingTimer: seconds });
            }, 1000);
            window.webkit.messageHandlers.showMessage.postMessage(['3', '2', '1']);
            return this.setState({ startAudio: true });
        }
        // Exception
        if (!navigator.mediaDevices)
            return this.props.showExceptionDialog();

        navigator.mediaDevices.getUserMedia({ audio: true, video: false })
            .then((stream) => {
                window.streamReference = stream;
                mediaRecorder = new MediaRecorder(stream);
                mediaRecorder.start();
                context = new AudioContext();
                mediaStream = context.createMediaStreamSource(stream);
                if (context.createScriptProcessor) {
                    recorder = context.createScriptProcessor(1024, 1, 1);
                } else {
                    recorder = context.createJavaScriptNode(1024, 1, 1);
                }
                const audioChunks = [];
                mediaRecorder.addEventListener('dataavailable', (e) => audioChunks.push(e.data))
                mediaRecorder.addEventListener('stop', async () => {
                    const audioBlob = new Blob(audioChunks, { type: 'audio/mp3' });
                    let base64 = await audioToBase64(audioBlob);
                    this._recordedAudio(base64, audioBlob);
                })
                mediaStream.connect(recorder);
                recorder.connect(context.destination);
                recorder.onaudioprocess = (e) => {
                    let seconds = Math.floor(e.playbackTime);
                    this.props.onRecordingProgress(seconds);
                    this.setState({ recordingTimer: seconds });
                }
                return this.setState({ startAudio: true });
            })
            .catch((error) => {
                console.log("Riddle Start Recording :-", error);
                this.props.showExceptionDialog();
            })
    }

    _recordedAudio = (base64, audioBlob) => {
        if (!audioBlob) audioBlob = new Blob([base64], { type: 'audio/wav' });

        let blobUrl = URL.createObjectURL(audioBlob);
        this.setState({
            audioBase64: base64,
            duration: this.state.recordingTimer,
            isAudioRecorded: true,
            audioPath: blobUrl,
            startAudio: false
        })
        this.props.onReceiveVoice(blobUrl, base64, this.state.recordingTimer);

        // let context = document.getElementById("riddleWave");
        // if (context !== null) {
        //     context = context.getContext("2d");
        //     createSoundWave("data:audio/mp3;base64," + base64, context, { color: "#fff", barLines: 100 });
        // }
    }

    _stopRecording = () => {
        clearInterval(this.interval_anim);
        this.setState({ isVoiceAnim: false });

        if (window.webkit && window.wv) {
            clearInterval(this.recordProgress);
            window.webkit.messageHandlers.showMessage.postMessage(['3', '2', '0']);
            return this.setState({ startAudio: false, recordingTimer: 0 });
        }
        recorder.disconnect(context.destination);
        mediaStream.disconnect(recorder);
        mediaRecorder.stop();
        if (!window.streamReference) return;
        window.streamReference.getAudioTracks().forEach((track) => {
            return track.stop();
        });
        return window.streamReference = null;
    }

    handleAudio = async () => {
        if (this.state.startAudio) {
            return this._stopRecording();
        }
        this.clearAudio();
        return this._startRecording();
    }

    onPlay = () => {
        const { audioPath } = this.state;
        if (this.SoundObject.playState === 1) {
            return this.SoundObject.stop()
        }
        this.SoundObject = soundManager.createSound({
            id: `sound_riddle_player_${audioPath}`,
            url: audioPath,
            // url: 'data:audio/mp3;base64,' + audioBase64,
            whileplaying: () => {
                let seconds = Math.floor(this.SoundObject.position / 1000.0);
                this.props.onPlayProgress(seconds);
                this.setState({ currentTime: Number(this.state.duration) - seconds, playAudio: true });
            },
            onfinish: () => {
                this.props.onPlayStop();
                this.setState({ playAudio: false, currentTime: "", duration: Math.floor(this.SoundObject.duration / 1000.0) });
            },
            onstop: () => {
                this.props.onPlayStop();
                this.setState({ playAudio: false, currentTime: "", duration: Math.floor(this.SoundObject.duration / 1000.0) });
            },
            onPlay: () => {
                console.log(this.SoundObject.duration)
            }
        });
        soundManager.stopAll();
        this.SoundObject.play()
    }

    clearAudio = async () => {
        try {
            if (this.SoundObject.playState === 1) return this.SoundObject.stop()
            if (!this.state.isAudioRecorded) return;
            if (this.state.startAudio) await this.handleAudio();
            this.setState({
                audioBase64: undefined,
                duration: "",
                currentTime: "",
                recordingTimer: "",
                isAudioRecorded: false
            });
            this.props.onClearvoice();
            console.log("voice path cleared!");
        } catch (error) {
            console.log("clearAudio", error);
        }
        return true;
    }

    render() {
        const { startAudio } = this.state
        return (
            <View style={pageStyles.modalArea}>
                <View style={pageStyles.circleButton}>
                    {startAudio &&
                        <CircleVoice style={{ width: 60, height: 60, backgroundColor: '#f44336', alignSelf: 'center', position: 'absolute', zIndex: 0 }} pose={this.state.isVoiceAnim ? "attention" : "attention2"} >
                        </CircleVoice>
                    }
                    <RoundedIcon
                        height={76}
                        color={this.state.startAudio ? "#FE2E47" : colors.indigo}
                        icon={(
                            <Icon
                                icon={this.state.startAudio ? faStop : faMicrophone}
                                size="lg"
                                color={colors.white}
                                style={{ position: "static" }}
                            />
                        )}
                        onPress={this.handleAudio}
                    />
                </View>

            </View>
        )
    }
}
export default Recorder;

const CircleVoice = posed.div({
    attention: {
        scale: 1.3,
        transition: {
            type: 'spring',
            stiffness: 200,
            damping: 0,
            delay: 500,
            duration: 700,
        },
        background: 'rgba(247, 119, 110, 1)',
        // boxShadow: '10px 10px 20px rgba(250, 179, 174, 1)',
        borderRadius: '50px',
    },
    attention2: {
        scale: 1.8,
        transition: {
            duration: 700,
            type: 'spring',
            stiffness: 250,
            delay: 500,
            damping: 3
        },
        borderRadius: '50px',
        background: 'rgba(247, 123, 114, 1)',
        // boxShadow: '10px 10px 20px rgba(250, 179, 174, 1)',
    },

})

const pageStyles = StyleSheet.create({
    modal: {
        margin: 0,
        backgroundColor: 'white',
        height: 200,
        flex: 0,
        bottom: 0,
        position: 'absolute',
        width: '100%'
    },
    modalArea: {
        alignItems: 'center',
        height: 76
    },
    circleButton: {
        flex: 1,
        justifyContent: 'center'
    }
})